import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {PropertyGroup} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {createProp} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/0->1-migration';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 4;

function findBindItem(propSnapshot:any, bindGroupName:string, path:FieldPath):any
{
    const bindGroup:any = Object.values(propSnapshot._bindGroups).find(
        (bindGroupSnapshot:any) => bindGroupSnapshot.name === bindGroupName
    );
    const bindItem:any = Object.values(bindGroup.rootBindItem.paths[0]).find(
        (bindGroupSnapshot:any) => bindGroupSnapshot.path === path
    );

    return bindItem;
}

export const migration_3_4:IMigration = {
    from: 3,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === 3);

        console.log('migration 3->4 designState', designState);

        if( designState.surface && designState.surface.artboard && designState.surface.artboard.allBoxes )
            Object.values(designState.surface.artboard.allBoxes).forEach((boxSnapshot:any) =>
            {
                const {componentDesc} = boxSnapshot;
                const oldRepeaterPropSnapshot:any = Object.values(componentDesc._baseProperties).find(
                    (propSnapshot:any) => propSnapshot.name === SystemPropsConfigs.REPEATER_PROP_NAME
                );
                const repeaterPropSnapshot:any = createProp(
                    componentDesc.boxId,
                    componentDesc.visualComponentId,
                    SystemPropsConfigs.basePropertiesConfigs.get(SystemPropsConfigs.REPEATER_PROP_NAME),
                    PropertyGroup.Base
                );
                const oldValuesBindItem:any = findBindItem(
                    oldRepeaterPropSnapshot,
                    'values',
                    'values'
                );
                const valuesBindItem:any = findBindItem(
                    repeaterPropSnapshot,
                    'values',
                    'values'
                );
                const oldCountBindItem:any = findBindItem(
                    oldRepeaterPropSnapshot,
                    'count',
                    'count'
                );
                const countBindItem:any = findBindItem(
                    repeaterPropSnapshot,
                    'count',
                    'count'
                );

                valuesBindItem.bindingId = oldValuesBindItem.bindingId;
                countBindItem.bindingId = oldCountBindItem.bindingId;
                repeaterPropSnapshot._value = {
                    count: oldRepeaterPropSnapshot._value.values ? oldRepeaterPropSnapshot._value.values.length : null,
                    displayType: {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'vertical',
                        'values': ['manual', 'vertical', 'horizontal', 'tiles']
                    },
                    offsetX: null,
                    offsetY: null,
                    numberOfColumns: null
                };

                delete componentDesc._baseProperties[oldRepeaterPropSnapshot.id];
                componentDesc._baseProperties[repeaterPropSnapshot.id] = repeaterPropSnapshot;
            });

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
